import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  size = 'md',
  onClick
}: CTAButtonProps) {
  const baseStyles = 'bg-[#10b981] hover:bg-[#059669] text-white font-bold uppercase tracking-wide transition-all duration-200 shadow-md hover:shadow-lg hover:scale-[1.02] flex items-center justify-center gap-2 rounded-sm';
  const sizeStyles = {
    sm: 'py-2 px-4 text-xs',
    md: 'py-3 px-6 text-xl',
    lg: 'py-4 px-8 text-xl'
  };
  return <button className={`${baseStyles} ${sizeStyles[size]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={onClick} data-id="element-10">
      {children}
      <ArrowRight size={size === 'lg' ? 24 : 16} strokeWidth={3} data-id="element-11" />
    </button>;
}